import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TenantAssets, DEFAULT_TENANT_ASSETS } from './tenant-theme.interface';
import { ConfigService } from '../config/config.service';

@Injectable({ providedIn: 'root' })
export class TenantAssetService {
  private assetsSubject = new BehaviorSubject<TenantAssets>(DEFAULT_TENANT_ASSETS);
  assets$: Observable<TenantAssets> = this.assetsSubject.asObservable();

  constructor(private configService: ConfigService) {}

  apply(assets: Partial<TenantAssets>): void {
    const resolved: TenantAssets = {
      logoUrl: this.resolveUrl(assets.logoUrl, DEFAULT_TENANT_ASSETS.logoUrl!),
      logoSmallUrl: this.resolveUrl(assets.logoSmallUrl, DEFAULT_TENANT_ASSETS.logoSmallUrl!),
      faviconUrl: this.resolveUrl(assets.faviconUrl, null),
    };
    this.assetsSubject.next(resolved);
  }

  getLogoUrl(): string {
    return this.assetsSubject.value.logoUrl ?? DEFAULT_TENANT_ASSETS.logoUrl!;
  }

  getLogoSmallUrl(): string {
    return this.assetsSubject.value.logoSmallUrl ?? DEFAULT_TENANT_ASSETS.logoSmallUrl!;
  }

  getFaviconUrl(): string | null {
    return this.assetsSubject.value.faviconUrl;
  }

  getSnapshot(): Readonly<TenantAssets> {
    return this.assetsSubject.value;
  }

  reset(): void {
    this.assetsSubject.next(DEFAULT_TENANT_ASSETS);
  }

  /**
   * Resuelve la URL de un asset del tenant.
   * - URL absoluta (http/https) → se usa tal cual (la API ya incluye el dominio del CDN)
   * - Path relativo + tenantCdnUrl configurado → se concatena con el CDN base
   * - null/vacío → se usa el fallback local
   */
  private resolveUrl(url: string | null | undefined, fallback: string | null): string | null {
    if (!url) {
      return fallback;
    }
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    const cdnBase = this.configService.tenantCdnUrl;
    if (cdnBase) {
      const base = cdnBase.replace(/\/+$/, '');
      const path = url.replace(/^\/+/, '');
      return `${base}/${path}`;
    }
    return fallback;
  }
}
